import React from "react";
import SelectList from "../SelectList.jsx";

/**
 * Farbwerte der Ampel-Zustände - Oskars tatsächliche Design-Farben aus der
 * Ampel-Datei (PLAN.md Abschnitt 1b, gegen die Excel-Datei aufgelöst:
 * grün #D7E4BD, gelb #FFFF00, rot #E6B9B8, rosa #F2DCDB). "weiss" kommt nur
 * aus der errechneten Rückfall-Ampel (DATENMODELL.md Tabelle 2, "Ist
 * erreicht Wunsch") und taucht in Oskars Datei selbst nicht auf.
 */
export const AMPEL_FARBEN = {
    gruen: "#D7E4BD",
    gelb: "#FFFF00",
    rot: "#E6B9B8",
    rosa: "#F2DCDB",
    weiss: "#ffffff",
};

export const AMPEL_LABEL = {
    gruen: "Grün",
    gelb: "Gelb",
    rot: "Rot",
    rosa: "Rosa",
    weiss: "Weiß",
};

/**
 * Legende für den Lieferplan-Kalender (AP7 B, PLAN.md Abschnitt 1b): Text
 * und Erklär-Hinweis je Ampelfarbe, inklusive "ohne Farbe" (Oskar hat die
 * Zelle nicht bewertet - die Tabelle zeigt dafür die errechnete
 * Rückfall-Ampel mit gestricheltem Rand). Bei "rot" und "ohne Farbe" ist die
 * genaue Lesart mit Oskar noch zu klären (Auftrag AP7 B).
 */
export const AMPEL_LEGENDE = [
    {farbe: "gruen", text: "Zusage deckt den Wunsch.", klaerung: false},
    {farbe: "gelb", text: "Teilmenge oder noch nicht zugesagt.", klaerung: false},
    {
        farbe: "rot",
        text: "In dieser Woche kommt nichts, verschoben.",
        klaerung: true,
    },
    {farbe: "rosa", text: "Neuer Vorschlag (Block „NEW - POSSIBLE ORDER“).", klaerung: false},
    {
        farbe: null,
        text: "Ohne Farbe – nicht bewertet.",
        klaerung: true,
    },
];

export const KLAERUNGSHINWEIS =
    "Die genaue Lesart ist mit Oskar noch zu klären (PLAN.md Abschnitt 1b) – für diese Zelle zeigt die Tabelle vorerst die errechnete Rückfall-Ampel.";

/** Kleiner Farbpunkt für die Ampel - eigene Darstellung statt Text allein. */
export function AmpelPunkt({farbe, size = 10, className = ""}) {
    return (
        <span
            aria-hidden="true"
            className={className}
            style={{
                display: "inline-block",
                width: size,
                height: size,
                borderRadius: "50%",
                backgroundColor: AMPEL_FARBEN[farbe] || "#ced4da",
                border: farbe === "weiss" || !farbe ? "1px solid #ced4da" : "none",
                flexShrink: 0,
            }}
        />
    );
}

const OPTIONEN = [
    {value: "", label: "– keine (errechnet) –"},
    ...Object.keys(AMPEL_FARBEN).map((farbe) => ({
        value: farbe,
        label: (
            <span className="d-inline-flex align-items-center gap-1">
                <AmpelPunkt farbe={farbe} /> {AMPEL_LABEL[farbe]}
            </span>
        ),
    })),
];

/**
 * Eigene Ampel-Auswahl (grün/gelb/rot/rosa/weiß mit Farbpunkt) für die
 * Lieferpositionen - von Hand gesetzt, hat immer Vorrang vor der
 * errechneten Rückfall-Ampel (UMSETZUNG.md C2, PLAN.md Abschnitt 1b: "Die
 * Ampel ist von Hand gesetzt, nicht gerechnet"). Kein natives `<select>`.
 */
export default function AmpelSelect({id, value, onChange, size = "sm", ariaLabel, disabled = false}) {
    return (
        <SelectList
            id={id}
            value={value || ""}
            options={OPTIONEN}
            onChange={(v) => onChange(v === "" ? null : v)}
            size={size}
            ariaLabel={ariaLabel}
            disabled={disabled}
        />
    );
}
